import { Injectable } from '@angular/core';
import { Company, CompanyMenu } from '@shared/definitions';
import { BehaviorSubject, Subject, filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ActiveCompanyService {
  private _companyMenu = new BehaviorSubject<CompanyMenu>(null);
  private companyMenu$ = this._companyMenu.asObservable().pipe(filter((e) => !!e));

  private _activeCompany: BehaviorSubject<Company> = new BehaviorSubject<Company>(null);
  activeCompany$ = this._activeCompany.asObservable();
  get activeCompany() {
    return this._activeCompany.value;
  }

  // The company's Metabase dashboards changed (PAUL-3755); the menu refetches them without a reload.
  private _reportsChanged = new Subject<void>();
  reportsChanged$ = this._reportsChanged.asObservable();

  constructor() {}

  setCompanyMenu(menu: CompanyMenu) {
    this._companyMenu.next(menu);
  }

  getCompanyMenu() {
    return this.companyMenu$;
  }

  setActiveCompany(company: Company) {
    this._activeCompany.next(company);
  }

  notifyReportsChanged() {
    this._reportsChanged.next();
  }
}
